// Redux selectors for the `auth` slice. The reducer is at
// src/store/reducers/AuthReducer.js — every selector here reads from
// `state.auth.<key>`, NOT `state.auth.auth.<key>` (the latter was a long-
// standing typo that left `getSelectedCompany` / `getAccessToken` /
// `getRefreshToken` / `getExpiresIn` returning empty strings forever; they
// had zero consumers, but shipped as broken public API).
//
// `getRefreshToken` / `getExpiresIn` are removed entirely — the reducer
// never stored them under any name, and nothing imports them.

export const isAuthenticated = (state) => {
  return state.auth.isAuthenticated;
};

export const isCompanySelected = (state) => {
  if (state.auth.selectedCompany && state.auth.selectedCompany.companyId) return true;
  return false;
};

export const getSelectedCompany = (state) => {
  if (state.auth.selectedCompany && state.auth.selectedCompany.companyId) {
    return state.auth.selectedCompany;
  }
  return '';
};

export const getAccessToken = (state) => state.auth.accessToken || '';

export const getUid = (state) => {
  if (state.auth.user && state.auth.user.googleUid)
    return state.auth.user.googleUid;
  else
    return '';
};

export const getSelectedCompanyType = (state) =>
  state?.auth?.selectedCompany?.companyType || '';

export const getSelectedVatStatus = (state) =>
  state?.auth?.selectedCompany?.vatStatus || '';

export const getSelectedRegistrationNumber = (state) =>
  state?.auth?.selectedCompany?.registrationNumber || '';
